// extracted by mini-css-extract-plugin
module.exports = {"DataTable":"DataTable_DataTable__3QC0e","CardTable":"DataTable_CardTable__HHGhQ","TableContainer":"DataTable_TableContainer__Vm_MZ","FilterForm":"DataTable_FilterForm__2ZqYG"};